import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import Vue from 'vue';
import { Job } from './job';
import { JobTagConfig } from './jobtagconfig';
import { ATSJobListParams } from './atsjoblistparams';
import axios from 'axios';
import { ResumePayload } from './resumepayload';
import { JobTokenPayload } from './jobTokenPayload';
import { ApplyRequest, ApplyRequestWrapper, Apply } from './jobapply';
import { Questionnaire } from './questionnaire';
import { SupportingInfoPayload } from './supportinginfoPayload';
import { UserAttributeWrapper } from './userattributewrapper';
import {
  QuestionnaireResponse,
  QuestionResponseData,
  QuestionnaireDetailRequest
} from './questionnaireresponse';
import { vxm } from '@/store.vuex';
import router from '../../router';
import { ResumeWrapper } from './resumeWrapper';
import { BrandingInfo } from '../branding/branding';
import { JobFilterWrapper } from './jobfilterwrapper';
import { Company } from '../company/companyprofile';
import { ResumeRecord } from './resumerecord';
import { JobApplication } from './jobapplication';
import { Pager } from './pager';
import { JobAlert } from './jobalert';
import { SurveyDetailRequest,SurveyFieldValidation } from '../candidatesurvey/candidatesurveyresponse';
import { SurveyQuestionResponse } from '../candidatesurvey/candidatesurveyresponse';
import { SurveyDetailResponse } from '../candidatesurvey/candidatesurveyresponse';
import { Survey } from '../candidatesurvey/candidatesurveyresponse';
import { CandidatePortalClientCommonInfo } from '../utility/lookup';
import { UserJobHistoryListRequest } from './userjobhistorylistrequest';
import { UserJobHistoryListResponse } from './userjobhistoryresponse';
import { UserJobHistory } from './userjobhistory';
import { UserJobHistoryUpdateResponse } from './userjobhistoryupdateresponse';
import { UserCompany } from './usercompany';
import { UserJobListRequest } from './userjoblistrequest';
import { UserJobStatusResponse } from './userjobstatusresponse';
import { WorkFlowStepSubmitRequest } from './../../components/MyJobs/JobListing/JobSubmitFLow';
import {InterviewAppointmentReject}from './../../components/MyJobs/JobListing/JobSubmitFLow';
import { CommonJobAlert } from '../JobAlert/commonjobalert';
import { CommonJobAlertV2 } from '../JobAlert/commonjobalertv2';
import { JobAlertListV2 } from '../JobAlert/JobAlertListV2';
import { JobAlertUI } from '../JobAlert/JobAlertUI';
import { UserJob } from './userjob';
import { JobSearchRequestPayload } from '@/components/SearchFilter/JobSearchRequestPayload';
import { JobDeleteV2 } from '../JobAlert/JobAlertDeleteV2';
import { JobAlertPauseV2 } from '../JobAlert/JobAlertPauseV2';
declare var window: any;

@Module({ namespacedPath: 'jobs/' })
export class JobsStore extends VuexModule {
  private anonymousJobByID: Job = new Job();
  private companyCode: string = '';
  private jobPostingId: number = 0;
  private joblistings: Job[] = [];
  private mapViewJobListing: Job[] = [];
  private jobAlertListings = [];
  private filterRadius: number = 3250;
  private maxSearchDistance: number = 3250;
  private adminMessage: string = '';
  private questionnaire: Questionnaire = new Questionnaire();
  private userAttributeWrapper: UserAttributeWrapper = new UserAttributeWrapper();
  private qaResponse: QuestionnaireResponse = new QuestionnaireResponse();
  private resumeWrapper: ResumeWrapper = new ResumeWrapper();
  private brandingInfo: BrandingInfo = new BrandingInfo();
  private jobFilterWrapper: JobFilterWrapper = new JobFilterWrapper();
  private companyInfo: Company = new Company();
  private defaultResume: ResumeRecord = new ResumeRecord();
  private applicationResponse: Apply = new Apply();
  private latLong: number[] = [];
  private brandingLogo: string = '';
  private jobPager: Pager = new Pager();
  private mapViewJobPager: Pager = new Pager();
  private jobHistoryPager: Pager = new Pager();
  private myJobsPager: Pager = new Pager();
  private myJobAlertPager: Pager = new Pager();
  private jobListParams: ATSJobListParams = new ATSJobListParams();
  private resultSize: number = 10;
  private surveyDetailResponse: SurveyDetailResponse = new SurveyDetailResponse();
  private surveyQuestionResponse: SurveyQuestionResponse = new SurveyQuestionResponse();
  private userJobHistoryListRequest: UserJobHistoryListRequest = new UserJobHistoryListRequest();
  private userJobHistoryListResponse: UserJobHistoryListResponse = new UserJobHistoryListResponse();
  public userJobHistoryListResponseCopy: any = {};
  private userJobHistoryUpdateReponse: UserJobHistoryUpdateResponse = new UserJobHistoryUpdateResponse();
  private userJobListRequest: UserJobListRequest = new UserJobListRequest();
  private userJobStatusResponse: UserJobStatusResponse = new UserJobStatusResponse();
  private guidedSignUpOccured: boolean = false;
  private searchFilterConfig: any = {
    jobTitle: '',
    location: '',
    jobType: '',
    jobSkills: [],
    industry: '',
    radius: '',
    sort: '',
    remoteWorkingJobs: '',
    categories: [],
    facilityTypes: [],
  };
  private customFilters: any = [];
  private userCompanyListing: UserCompany[] = [];
  private jobAlerts: JobAlertUI[] = [];
  private saveJobResult: any = {
    resultcount: 0,
    resultSize: 0,
    resultPage: 1,
  };
  private savedjoblistings: Job[] = [];
  private jobHistoryCustomData: [] = [];
  private jobHistoryReasonForLeavingData: [] = [];
  private activeConversationGuid: String = '';
  private jobApplicationWorkflowStepsData: any = {};
  private reasonCodes:[]=[];
  private jobAlertid: number = 0;
  public filterForJobAlerts: boolean = false;
  public jobAlertFilters: [] = [];
  private jobAdminMessage: string = '';
  private userJob: UserJob = new UserJob();
  private cityId: number = 0;
  private skillTypeId: number = 0;
  private jobAlertLocationInfo: any = [];
  private alertRefresh: boolean = false;
  private industryTypeId: number = 0;
  private skipGuidedSignUpOnRegistration: boolean = false;
  private skipGuidedSignUpOnApplication: boolean = false;
  private mapViewMode: boolean = false;
  private appliedJob: string = '';
  private jobTagConfigs: JobTagConfig[] = [];
  private jobListParamsV2: JobSearchRequestPayload = new JobSearchRequestPayload();
  private _: any;
  private searchV2Active: boolean = false;
  private filterMetaData: [] = [];
  private similarJobs: Job[] = [];
  private jobAlertFilterURL: any = [];
  private callEngagementService: boolean = true;
  private supportDocFromEngagementService : boolean = true;
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  public get FilterMetaData(): [] {
    return this.filterMetaData;
  }

  public get FilterForJobAlerts(): boolean {
    return this.filterForJobAlerts;
  }
  public get SearchV2Active(): boolean {
    return this.searchV2Active;
  }

  public get JobAdminMessage(): string {
    return this.jobAdminMessage;
  }

  public get UserJob(): UserJob {
    return this.userJob;
  }

  public get JobAlertFilterURL(): any {
    return this.jobAlertFilterURL;
  }

  public get jobApplicationWorkflowSteps(): any {
    return this.jobApplicationWorkflowStepsData;
  }
  public get interviewManagementReasonCodes(): any {
    return this.reasonCodes;
  }

  public get jobHistoryReasonForLeavingObj(): any {
    return this.jobHistoryReasonForLeavingData;
  }

  public get jobHistoryCustomDataObj(): any {
    return this.jobHistoryCustomData;
  }

  public get searchFilterObj(): any {
    return this.searchFilterConfig;
  }

  public get JobListParamsV2(): JobSearchRequestPayload {
    return this.jobListParamsV2;
  }

  public get JobListParams(): ATSJobListParams {
    return this.jobListParams;
  }

  public get JobPager(): Pager {
    return this.jobPager;
  }

  public get MapViewJobPager(): Pager {
    return this.mapViewJobPager;
  }

  public get JobHistoryPager(): Pager {
    return this.jobHistoryPager;
  }

  public get MyJobsPager(): Pager {
    return this.myJobsPager;
  }
  public get MyJobAlertPager(): Pager {
    return this.myJobAlertPager;
  }

  public get BrandingLogo(): string {
    return this.brandingLogo;
  }

  public get jobId(): number {
    return this.jobPostingId;
  }

  public get CustomFilters() {
    return this.customFilters;
  }

  public get getCompanyLogoUrl() {
    return (companyCode = vxm.jobs.companyCode) => {
      const COMPANY_LOGO_URL = vxm.configs.getGlobalConfigValue(
        'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
      );
      const LOGO_FILE_SEPERATOR = '/';
      const LOGO_FILE = vxm.utility.companyLogoFile;
      const CompanyLogoUrl =
        COMPANY_LOGO_URL +
        LOGO_FILE_SEPERATOR +
        companyCode +
        LOGO_FILE_SEPERATOR +
        LOGO_FILE;
      return CompanyLogoUrl;
    };
  }

  public get getSeoLogoUrl() {
    const LOGO_FILE =
      vxm.configs.getGlobalConfigValue('SEO_LOGO_FILE') ||
      vxm.utility.companyLogoFile;
    console.log(
      'vxm.configs.getGlobalConfigValue("SEO_LOGO_FILE") || vxm.utility.companyLogoFile',
      LOGO_FILE,
    );
    return (companyCode = vxm.jobs.companyCode) => {
      const COMPANY_LOGO_URL = vxm.configs.getGlobalConfigValue(
        'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
      );
      return `${COMPANY_LOGO_URL}/${companyCode}/${LOGO_FILE}`;
    };
  }

  public get getCompanyRadiusMax(): string {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return vxm.configs.ClientConfigs.companyPreference.companyRadiusMax
    }
    return vxm.jobs.BrandingInfo.COMPANY_RADIUS_MAX;
  }

  public get getCompanyRadiusMin(): string {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return vxm.configs.ClientConfigs.companyPreference.companyRadiusMin
    }
    return vxm.jobs.BrandingInfo.COMPANY_RADIUS_MIN;
  }

  public get getCompanyDistanceUnit(): string {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return vxm.configs.ClientConfigs.companyPreference.companyDistanceUnit
    }
    return vxm.jobs.BrandingInfo.COMPANY_DISTANCE_UNIT === '02'
      ? 'kilometers'
      : 'miles';
  }

  public get getCompanyDateFormat(): string {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return vxm.configs.ClientConfigs.companyPreference.companyDateFormat
    }
    if (
      vxm.jobs.BrandingInfo.COMPANY_DATE_FORMAT &&
      vxm.jobs.BrandingInfo.COMPANY_DATE_FORMAT.toUpperCase().includes('HH')
    ) {
      return vxm.jobs.BrandingInfo.COMPANY_DATE_FORMAT.substring(
        0,
        vxm.jobs.BrandingInfo.COMPANY_DATE_FORMAT.toUpperCase().indexOf('HH') -
        1,
      );
    }
    return vxm.jobs.BrandingInfo.COMPANY_DATE_FORMAT;
  }

  public get getCompanyCountryCode(): string {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return vxm.configs.ClientConfigs.companyPreference.companyCountryCode
    }
    return vxm.jobs.BrandingInfo.COMPANY_COUNTRY_CODE;
  }

  public getCompanyCode(): string {
    return this.companyCode;
  }

  public get Jobs(): Job[] {
    return this.joblistings;
  }

  public get MapViewJobListing(): Job[] {
    return this.mapViewJobListing;
  }

  public get JobTagConfigs(): JobTagConfig[] {
    return this.jobTagConfigs;
  }

  public get DefaultResume(): ResumeRecord {
    return this.defaultResume;
  }

  public get AdminMessage(): string {
    return this.adminMessage;
  }

  public get Job(): Job[] {
    if (this.joblistings && this.joblistings.length > 0) {
      return this.joblistings.filter(
        (j) => j.jobPostingId === this.jobPostingId,
      );
    } else {
      return [new Job()];
    }
  }

  public get Questionnaire(): Questionnaire {
    return this.questionnaire;
  }

  public get SupportingInfo(): UserAttributeWrapper {
    return this.userAttributeWrapper;
  }

  public get QAResponse(): QuestionnaireResponse {
    return this.qaResponse;
  }

  public get resumeListing(): ResumeWrapper {
    return this.resumeWrapper;
  }

  public get BrandingInfo(): BrandingInfo {
    return this.brandingInfo;
  }

  public get jfWrapper(): JobFilterWrapper {
    return this.jobFilterWrapper;
  }

  public get CompanyInfo(): Company {
    return this.companyInfo;
  }

  public get FilterRadius(): number {
    return this.filterRadius;
  }

  public get latitude(): number {
    return this.latLong[0];
  }

  public get longitude(): number {
    return this.latLong[1];
  }

  public get AnonymousJobByID() {
    return this.anonymousJobByID;
  }

  public get ApplicationResponse(): Apply {
    return this.applicationResponse;
  }

  public get ResultSize(): number {
    return this.resultSize;
  }

  public get SurveyDetailResponse(): SurveyDetailResponse {
    return this.surveyDetailResponse;
  }

  public get SurveyQuestionResponse(): SurveyQuestionResponse {
    return this.surveyQuestionResponse;
  }

  public get UserJobHistoryListRequest(): UserJobHistoryListRequest {
    return this.userJobHistoryListRequest;
  }

  public get UserJobHistoryListResponse(): UserJobHistoryListResponse {
    return this.userJobHistoryListResponse;
  }

  public get UserJobHistoryUpdateResponse(): UserJobHistoryUpdateResponse {
    return this.userJobHistoryUpdateReponse;
  }

  public get UserJobListRequest(): UserJobListRequest {
    return this.userJobListRequest;
  }

  public get UserJobStatusResponse(): UserJobStatusResponse {
    return this.userJobStatusResponse;
  }

  public get UserCompanyListing(): UserCompany[] {
    return this.userCompanyListing;
  }

  public get UserJobAlerts(): JobAlertUI[] {
    return this.jobAlerts;
  }

  public get ResultCount(): any {
    return this.saveJobResult;
  }

  public get SavedJobs(): Job[] {
    return this.savedjoblistings;
  }
  public get CityId(): number {
    return this.cityId;
  }
  public get SkillTypeId(): number {
    return this.skillTypeId;
  }
  public get IndustryTypeId(): number {
    return this.industryTypeId;
  }

  public get AppliedJob(): string {
    return this.appliedJob;
  }

  public get SimilarJobs(): Job[] {
    return this.similarJobs;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setJobAdminMessage(adminMessage) {
    this.jobAdminMessage = adminMessage;
  }
  @mutation
  public setFilterForJobAlerts(val: boolean) {
    this.filterForJobAlerts = val;
  }

  @mutation
  public setFilterMetaData(filterMetaData) {
    this.filterMetaData = filterMetaData;
  }

  @mutation
  public setSearchV2Active(flag) {
    this.searchV2Active = flag;
  }

  @mutation
  public setJobApplicationWorkflowSteps(jobApplicationWorkflowStepsData): any {
    this.jobApplicationWorkflowStepsData = jobApplicationWorkflowStepsData;
  }

  @mutation
  public setInterviewManagementReasonCodes(reasonCodes):any{
    this.reasonCodes = reasonCodes;
  }

  public get ActiveConversationGUID(): String {
    return this.activeConversationGuid;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setUserJob(userJob: UserJob) {
    this.userJob = userJob;
  }

  @mutation
  public setActiveConversationGUID(activeConversationGuid: String) {
    this.activeConversationGuid = activeConversationGuid;
  }

  @mutation
  public setJobHistoryReasonForLeavingObj(jobHistoryReasonsForLeavingObj: any) {
    this.jobHistoryReasonForLeavingData = jobHistoryReasonsForLeavingObj;
  }

  @mutation
  public setJobHistoryCustomDataObj(jobHistoryCustomData: any) {
    this.jobHistoryCustomData = jobHistoryCustomData;
  }

  @mutation
  public setJobListParamsV2(jlp: JobSearchRequestPayload) {
    this.jobListParamsV2 = jlp;
  }

  @mutation
  public setJobListParams(jlp: ATSJobListParams) {
    this.jobListParams = jlp;
  }

  @mutation
  public setFilterRadius(radius: number) {
    this.filterRadius = radius;
  }

  @mutation
  public setBrandingLogo(bLogo: string) {
    this.brandingLogo = bLogo;
    // removing existing session data and adding updated data
    if (sessionStorage && sessionStorage.getItem('brandingLogo')) {
      sessionStorage.removeItem('brandingLogo');
    } else {
      if (Vue.cookies.get('brandingLogo')) {
        Vue.cookies.remove('brandingLogo');
      }
    }
    if (sessionStorage) {
      sessionStorage.setItem('brandingLogo', bLogo);
    } else {
      Vue.cookies.set('brandingLogo', bLogo);
    }
  }

  @mutation
  public setCustomFilters(payload) {
    this.customFilters = payload;
  }

  @mutation
  public setJobPager(jp: Pager) {
    jp.totalPages = Math.ceil(jp.resultCount / jp.resultSize);
    this.jobPager = jp;
  }

  @mutation
  public setMapViewJobPager(jp: Pager) {
    jp.totalPages = Math.ceil(jp.resultCount);
    this.mapViewJobPager = jp;
  }

  @mutation
  public setJobHistoryPager(jp: Pager) {
    jp.totalPages = Math.ceil(jp.resultCount / jp.resultSize);
    this.jobHistoryPager = jp;
  }

  @mutation
  public setMyJobsPager(jp: Pager) {
    jp.totalPages = Math.ceil(jp.resultCount / jp.resultSize);
    this.myJobsPager = jp;
  }

  @mutation
  public setMyAlertPager(jp: Pager) {
    jp.totalPages = Math.ceil(jp.resultSize / jp.resultCount);
    this.myJobAlertPager = jp;
  }

  @mutation
  public setUserJobHistoryListResponseCopy(uhlr: any) {
    if (uhlr.jobHistoryMetaData) {
      uhlr.jobHistoryMetaData.sort((a, b) => a.sequence - b.sequence);
    }
    this.userJobHistoryListResponseCopy = uhlr;
  }
  public get UserJobHistoryListResponseCopy(): any {
    return this.userJobHistoryListResponseCopy;
  }

  @mutation
  public setCompanyCode(companyCode: string) {
    this.companyCode = companyCode;
  }

  @mutation
  public setJobID(JobID: number) {
    this.jobPostingId = JobID;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setDefaultResume(def: ResumeRecord) {
    this.defaultResume = def;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setJobListings(jobs: Job[]) {
    this.joblistings = jobs;
  }

  @mutation
  public setJobTags(jobTagConfigs: JobTagConfig[]) {
    this.jobTagConfigs = jobTagConfigs;
  }

  @mutation
  public setSavedJobListings(jobs: Job[]) {
    this.savedjoblistings = jobs;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setMapViewJobListings(jobs: Job[]) {
    this.mapViewJobListing = jobs;
  }

  @mutation
  appendMapViewLoadedJobs(jobs: Job[]) {
    try {
      if (jobs) {
        if (!this.mapViewMode) {
          this.mapViewJobListing = [];
        }
        jobs.forEach(job => {
          const existing = this.mapViewJobListing.find(x => x.jobPostingId == job.jobPostingId);
          if (!existing) {
            this.mapViewJobListing.push(job);
          }
        });
      }
    } catch (exc) {
      console.log(exc);
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////


  @mutation
  public setAdminMessage(msg: string) {
    this.adminMessage = msg;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setQuestionnaire(q: Questionnaire) {
    this.questionnaire = q;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setSupportingInfo(u: UserAttributeWrapper) {
    this.userAttributeWrapper = u;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setQAResponse(qr: QuestionnaireResponse) {
    this.qaResponse = qr;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setResumeListing(rl: ResumeWrapper) {
    this.resumeWrapper = rl;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setSearchFilterObj(obj: any) {
    this.searchFilterConfig = obj;
  }

  @mutation
  public setBrandingInfo(bi: BrandingInfo) {
    this.brandingInfo = bi;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setFilterWrapper(jrw: JobFilterWrapper) {
    this.jobFilterWrapper = jrw;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setCompanyInfo(cpi: Company) {
    this.companyInfo = cpi;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setAnonymousJobByID(aj: Job) {
    this.anonymousJobByID = aj;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setLatLong(arr: number[]) {
    this.latLong = arr;
    console.log(['In Mutation', arr, this.latLong]);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setApplicationResponse(apply: Apply) {
    this.applicationResponse = apply;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setSurveyDetailResponse(surveyDetailResponse: SurveyDetailResponse) {
    this.surveyDetailResponse = surveyDetailResponse;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  @mutation
  public setResultSize(size: number) {
    this.resultSize = size;
  }

  @mutation
  public setUserJobHistoryListRequest(uhlr: UserJobHistoryListRequest) {
    this.userJobHistoryListRequest = uhlr;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setUserJobHistoryListResponse(uhlr: UserJobHistoryListResponse) {
    if (uhlr.jobHistoryMetaData) {
      uhlr.jobHistoryMetaData.sort((a, b) => a.sequence - b.sequence);
    }
    else {
      uhlr.jobHistoryMetaData = [];
    }
    this.userJobHistoryListResponse = uhlr;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setUserJobHistoryUpdateResponse(uhur: UserJobHistoryUpdateResponse) {
    this.userJobHistoryUpdateReponse = uhur;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setUserJobListRequest(jhlr: UserJobListRequest) {
    this.userJobListRequest = jhlr;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setUserJobHStatusResponse(ujsr: UserJobStatusResponse) {
    this.userJobStatusResponse = ujsr;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setUserCompanyListing(ucl: UserCompany[]) {
    this.userCompanyListing = ucl;
  }

  @mutation
  public setJobAlerts(jobAlerts: JobAlertUI[]) {
    this.jobAlerts = jobAlerts;
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setResultCount(obj: any) {
    this.saveJobResult = obj;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setCityId(cityId: number) {
    this.cityId = cityId;
  }
  @mutation
  public setSkillTypeId(skillTypeId: number) {
    this.skillTypeId = skillTypeId;
  }
  @mutation
  public setIndustryTypeId(industryTypeId: number) {
    this.industryTypeId = industryTypeId;
  }

  @mutation
  public setAppliedJob(appliedJob: string) {
    console.log('setting applied job to:' + appliedJob);
    this.appliedJob = appliedJob;
  }
  public get SkipGuidedSignUpOnRegistration(): boolean {
    return this.skipGuidedSignUpOnRegistration;
  }

  @mutation
  public setSkipGuidedSignUpOnRegistration(value: boolean) {
    this.skipGuidedSignUpOnRegistration = value;
  }
  public get SkipGuidedSignUpOnApplication(): boolean {
    return this.skipGuidedSignUpOnApplication;
  }
  @mutation
  public setGuidedSignUpOccured(value: boolean) {
    this.guidedSignUpOccured = value;
  }
  public get GuidedSignUpOccured(): boolean {
    return this.guidedSignUpOccured;
  }
  @mutation
  public setSkipGuidedSignUpOnApplication(value: boolean) {
    this.skipGuidedSignUpOnApplication = value;
  }
  @mutation
  public setSimilarJobs(similarJobs: Job[]) {
    this.similarJobs = similarJobs;
  }

  @action({ mode: 'mutate' })
  public async loadLatLong() {
    console.log('loadLatLong', navigator.geolocation);
    if (navigator.geolocation) {
      const resp = await navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setLatLong([
            position.coords.latitude,
            position.coords.longitude,
          ]);
          this.loadJobs();
        },
        (error) => {
          alert(error.message);
          this.loadJobs();
        },
      );
    } else {
      alert('Geolocation is not supported by this browser.');
      this.loadJobs();
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Change to leverage browser geolocation params

  ////////////////////////////////////////////////////////////////////////////////////////////////////////
  @mutation
  public setJobAlertId(id): any {
    this.jobAlertid = id;
  }

  public get JobAlertId(): number {
    return this.jobAlertid;
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async loadJobs() {
    console.log(['LatLong', this.latitude, this.longitude]);
    console.log(this.brandingInfo.companycode, '***this.brandingInfo');
    if (vxm.users.isLoggedIn) {
      this.setResultSize(this.jobListParams.resultSize);
    }
    if (this.jobListParams && !this.jobListParams.sortCriteria.sortField) {
      this.jobListParams.sortCriteria.sortField = '05';
    }
    if (
      this.jobListParams &&
      this.jobListParams.sortCriteria.sortField === '05'
    ) {
      this.jobListParams.sortCriteria.sortOrderAsc = true;
    }
    if (
      this.jobListParams.sortCriteria.sortField &&
      this.jobListParams.sortCriteria.sortField === 'JobPosting.createdDTTM'
    ) {
      this.jobListParams.sortCriteria.sortField = '05';
    }
    if (
      this.jobListParams.sortCriteria.sortField &&
      this.jobListParams.sortCriteria.sortField === 'JobPosting.jobPublishDTTM'
    ) {
      this.jobListParams.sortCriteria.sortField = '01';
    }
    let resp;
    this.jobListParams.filter.companyCode = this.brandingInfo.companycode;
    this.jobListParams.filter.radius = this.filterRadius;
    let geoLocation = this.jobListParams.geoLocation;
    if (
      geoLocation &&
      geoLocation.latLong &&
      !(geoLocation.latLong.latitude && geoLocation.latLong.longitude)
    ) {
      this.jobListParams.geoLocation.latLong = {
        latitude: this.latitude,
        longitude: this.longitude,
      };
      this.jobListParams.Location = {
        latitude: this.latitude,
        longitude: this.longitude,
      };
      this.jobListParams.geoLocation.requestPref = 'LATLONG';
    }

    if (this.brandingInfo.companycode) {
      if (vxm.users.isLoggedIn) {
        const bearerToken = 'Bearer ' + vxm.users.getToken;

        if (
          this.searchFilterConfig.categories &&
          this.searchFilterConfig.categories.length
        ) {
          this.jobListParams.filter.categoryIds = this.searchFilterConfig.categories;
        }

        resp = await axios.post(
          '/wl-jobs-svc/api/v1/jobs',
          this.jobListParams,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: bearerToken,
            },
          },
        );
      } else {
        this.setFilterRadius(this.maxSearchDistance);
        const filter: any = {
          companyCode: this.brandingInfo.companycode,
          radius: this.filterRadius,
          skillTypes: this.jobListParams.filter.skillTypes,
          industryTypes: this.jobListParams.filter.industryTypes,
          facilityId: this.jobListParams.filter.facilityId,
        };
        if (
          this.searchFilterConfig.categories &&
          this.searchFilterConfig.categories.length
        ) {
          filter.categoryIds = this.searchFilterConfig.categories;
        }
        resp = await axios.post(
          '/wl-jobs-svc/api/anon/job-posting',
          {
            filter,
            resultSize: this.jobListParams.resultSize,
            resultPage: this.jobListParams.resultPage,
            geoLocation: {
              latLong: {
                latitude: this.latitude,
                longitude: this.longitude,
              },
              requestPref: 'LATLONG',
            },
            keywords: '',
            Location: {
              latitude: this.latitude,
              longitude: this.longitude,
            },
            sortCriteria: {
              sortField: '05',
              sortOrderAsc: true,
            },
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
      }

      const pg = new Pager();
      pg.resultCount = resp.data.resultCount;
      pg.resultSize = resp.data.resultSize;
      pg.resultPage = resp.data.resultPage;
      this.setJobPager(pg);
      this.setJobListings(resp.data.publishedJobs);
      this.setJobTags(resp.data.tagConfigs);
      if (
        resp.data &&
        resp.data.appReferralBanner &&
        resp.data.appReferralBanner.appReferralBannerHtmlText
      ) {
        this.setAdminMessage(
          resp.data.appReferralBanner.appReferralBannerHtmlText,
        );
      }
      return resp;
      // this.getJobFilters(this.companyCode);
    } else {
      axios
        .get('/atsuser/api/v1/company', {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          let bInfo = new BrandingInfo();
          bInfo = response.data;
          this.setCompanyCode(bInfo.companycode);
          this.setFilterRadius(this.maxSearchDistance);
          //this.loadJobs();
        })
        .catch((error) => {
          // handle error
          console.log('catch:', error);
        })
        .finally(() => {
          // always executed
          console.log('finally');
        });
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async reloadJobsV2(jparams: JobSearchRequestPayload) {
    let resp;
    const companyCode = vxm.users.getCompanyCode;
    const url = `/wl-jobs-svc/api/v2/jobpostings/${companyCode}`;
    if (vxm.users.isLoggedIn) {
      const bearerToken = 'Bearer ' + vxm.users.getToken;
      resp = await axios.post(url, jparams, {
        params: {
          locale: vxm.utility.langaugeRegionMapping
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      });
    } else {
      resp = await axios.post(url, jparams, {
        headers: { 'Content-Type': 'application/json' },
      });
    }

    const pg = new Pager();
    pg.resultCount = resp.data.resultCount;
    pg.resultSize = resp.data.resultSize;
    pg.resultPage = resp.data.resultPage;
    this.setJobPager(pg);
    this.setJobListings(resp.data.publishedJobs);
    this.setJobTags(resp.data.tagConfigs);
    this.setSearchV2Active(true);
    this.appendMapViewLoadedJobs(resp.data.publishedJobs);
    // this.getBrandingInfo();
    if (
      resp.data.appReferralBanner &&
      resp.data.appReferralBanner.appReferralBannerHtmlText
    ) {
      this.setAdminMessage(
        resp.data.appReferralBanner.appReferralBannerHtmlText,
      );
    }

    // this.getJobFilters(this.companyCode);
    return resp.data;
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async reloadJobs(jparams: ATSJobListParams) {
    jparams.filter.companyCode = this.brandingInfo.companycode;
    jparams.filter.radius = this.filterRadius;

    if (!jparams.geoLocation.latLong.latitude) {
      jparams.geoLocation.latLong = {
        latitude: this.latitude,
        longitude: this.longitude,
      };
    }

    console.log(jparams);
    jparams.geoLocation.requestPref = 'LATLONG';
    this.setJobListParams(jparams);
    let resp;
    if (vxm.users.isLoggedIn) {
      const bearerToken = 'Bearer ' + vxm.users.getToken;
      resp = await axios.post('/wl-jobs-svc/api/v1/jobs', jparams, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      });
    } else {
      resp = await axios.post('/wl-jobs-svc/api/anon/job-posting', jparams, {
        headers: { 'Content-Type': 'application/json' },
      });
    }

    console.log(resp.data);

    const pg = new Pager();
    pg.resultCount = resp.data.resultCount;
    pg.resultSize = resp.data.resultSize;
    pg.resultPage = resp.data.resultPage;
    this.setJobPager(pg);
    this.setJobListings(resp.data.publishedJobs);
    this.setJobTags(resp.data.tagConfigs);
    // this.getBrandingInfo();
    if (
      resp.data.appReferralBanner &&
      resp.data.appReferralBanner.appReferralBannerHtmlText
    ) {
      this.setAdminMessage(
        resp.data.appReferralBanner.appReferralBannerHtmlText,
      );
    }

    // this.getJobFilters(this.companyCode);
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getAdditionalStepsInfo(jobTokenPayload: JobTokenPayload) {
    const bearerToken = 'Bearer ' + jobTokenPayload.token;
    const payLoadUrl =
      '/wl-jobs-svc/api/v1/apply/getAdditionalStepsInfo?jobPostingid=' +
      jobTokenPayload.jobID;
    const resp = await axios.get(payLoadUrl, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    return resp;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getQuetionaireListing(jobTokenPayload: JobTokenPayload) {
    const bearerToken = 'Bearer ' + jobTokenPayload.token;
    const payLoadUrl =
      '/wl-jobs-svc/api/v1/apply/questionnaires?jobPostingid=' +
      jobTokenPayload.jobID;
    const resp = await axios.get(payLoadUrl, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });

    const questionnaire = new Questionnaire();
    questionnaire.questions = resp.data;
    this.setQuestionnaire(questionnaire);
    console.log(questionnaire);
    const qaResponse = new QuestionnaireResponse();
    qaResponse.jobPostingId = jobTokenPayload.jobID + '';
    questionnaire.questions.forEach((elm) => {
      const qrData = new QuestionResponseData();
      qrData.questionID = elm.questionID + '';

      if (elm.questionType === '01') {
        elm.answerList.forEach(() => {
          qrData.userQuestionResponse.userAnswerList.push('');
        });
      }

      if (elm.questionType === '03' || elm.questionType === '12' ) {
        qrData.userQuestionResponse.userAnswerList.push('');
      }

      qaResponse.questionResponseData.push(qrData);
    });

    this.setQAResponse(qaResponse);
    return questionnaire;
  }

  @action({ mode: 'mutate' })
  public async getBranchedQuestionaireListing(QuestionnaireDetailRequest){
    console.log("QuestionnaireResponse",QuestionnaireDetailRequest);
    // const bearerToken = 'Bearer ' + BranchedQuestionnaireResponse.token;
    const payLoadUrl = '/engagement/api/v2/questionnaires';
    const resp = await axios.post(payLoadUrl,QuestionnaireDetailRequest,
    {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    console.log("resp..",resp.data);
    return resp.data;
  }


  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async saveMyJobsQuestionnaire(
    jobTokenPayload: JobTokenPayload,
    QAResponse: QuestionnaireResponse,
  ) {
    const bearerToken = 'Bearer ' + jobTokenPayload.token;
    const payLoadUrl = '/wl-jobs-svc/api/v1/apply/questions';
    const resp = await axios.post(payLoadUrl, QAResponse, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    let apply = new Apply();
    apply = resp.data;
    return apply;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async fetchFiltersData() {
    const companyCode = vxm.users.getCompanyCode;
    const lang = vxm.utility.langaugeRegionMapping;
    const resp = await axios.get(
      `/wl-jobs-svc/api/v5/jobfiltermetadatas/${companyCode}`,
      {
        params: {
          locale: lang
        },
        headers: {},
      },
    );
    const filterData =
      resp && resp.data && resp.data.data ? resp.data.data : null;
    if (
      filterData &&
      filterData.jobFilterMetaDataVOList &&
      filterData.jobFilterMetaDataVOList.length > 0
    ) {
      this.setFilterMetaData(filterData.jobFilterMetaDataVOList);
    }
    return resp ? resp.data : null;
  }

  @action({ mode: 'mutate' })
  public async fetchSkillsData(industryTypeIds: string) {
    const resp = await axios.get(
      `/wl-jobs-svc/api/v1/jobfiltermetadatas/industryverticals/${industryTypeIds}/skilltypes`,
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async saveQuestionnaire(jobTokenPayload: JobTokenPayload) {
    const bearerToken = 'Bearer ' + jobTokenPayload.token;
    const payLoadUrl = '/wl-jobs-svc/api/v1/apply/questions';
    const resp = await axios.post(payLoadUrl, this.QAResponse, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    console.log(resp.data);
    let apply = new Apply();
    apply = resp.data;
    return apply;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getSupportingInfo(jobTokenPayload: JobTokenPayload) {
    const bearerToken = 'Bearer ' + jobTokenPayload.token;
    const payLoadUrl =
      '/wl-jobs-svc/api/v1/apply/supportinginfos?jobpostingid=' +
      jobTokenPayload.jobID;
    const resp = await axios.get(payLoadUrl, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });

    let supportingInfo = new UserAttributeWrapper();
    supportingInfo = resp.data;
    supportingInfo.jobPostingId = jobTokenPayload.jobID;
    supportingInfo.userId = vxm.users.myUserProfile.userId;

    this.setSupportingInfo(supportingInfo);
    return supportingInfo;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  @mutation
  public setJobAlertFilterURL(filter: any) {
    this.jobAlertFilterURL = filter;
  }
  ///////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async postSupportingInfo(payload: SupportingInfoPayload) {
    const bearerToken = 'Bearer ' + payload.token;
    const formData = new FormData();

    if (!payload.referralCode) {
      payload.referralCode = vxm.referrals.globalRefCode;
    }

    // tslint:disable-next-line: max-line-length
    const doc1Text = `{
      'userAttributeID': 2001,
      'name': 'Driver License / Government Issued ID',
      'desc': 'Driver License / Government Issued ID',
      'label': 'Driver License / Government Issued ID',
      'attributeType': '02',
      'attributeCode': '01',
      'attributeRequired': true,
      'attributeValue': null,
      'userAttributeDocument': {
          'documentExtType': 'jpg'
      }
  },`;

    // tslint:disable-next-line: max-line-length
    const doc2Text = `{
      'userAttributeID': 2002,
      'name': 'Degree / Diploma',
      'desc': 'Degree / Diploma',
      'label': 'Degree / Diploma',
      'attributeType': '02',
      'attributeCode': '02',
      'attributeRequired': true,
      'attributeValue': null,
      'userAttributeDocument': {
          'documentExtType': 'jpg'
      }
  },`;

    // tslint:disable-next-line: max-line-length
    const doc3Text = `{
      'userAttributeID': 2003,
      'name': 'WMS Certification',
      'desc': 'WMS Certification',
      'label': 'WMS Certification',
      'attributeType': '02',
      'attributeCode': '03',
      'attributeRequired': false,
      'attributeValue': null,
      'userAttributeDocument': {
          'documentExtType': 'jpg'
      }
  }`;

    if (payload.doc1) {
      const idx = payload.doc1.name.lastIndexOf('.');
      const fileExt = payload.doc1.name.substring(idx + 1);
      formData.append('2001', payload.doc1);
      payload.supportingInfo += doc1Text;
    }
    if (payload.doc2) {
      const idx = payload.doc2.name.lastIndexOf('.');
      const fileExt = payload.doc2.name.substring(idx + 1);
      formData.append('2002', payload.doc2);
      payload.supportingInfo += doc2Text;
    }

    if (payload.doc3) {
      const idx = payload.doc3.name.lastIndexOf('.');
      const fileExt = payload.doc3.name.substring(idx + 1);
      formData.append('2003', payload.doc3);
      payload.supportingInfo += doc3Text;
    }

    (payload.supportingInfo =
      `{
      'userId': '` +
      payload.userId +
      `',
      'jobPostingId': '` +
      payload.jobID +
      `',
      'userAttributeList':` +
      this.SupportingInfo.userAttributeList),
      `'referralCode': ` + payload.referralCode
        ? payload.referralCode
        : '' +
        `,
      'userattributeFileMap': {}
    }`;
    const userid = payload.userId + '';
    const jobPostingId = payload.jobID + '';
    const userAttributeList = this.SupportingInfo.userAttributeList;
    console.log(userAttributeList);
    const newPayload = {
      userId: userid,
      jobPostingId: jobPostingId,
      userAttributeList: userAttributeList,
      referralCode: '',
      userattributeFileMap: {},
    };
    const pay =
      '{ "userId": ' +
      userid +
      ', "jobPostingId": ' +
      jobPostingId +
      ', "userAttributeList": [' +
      userAttributeList +
      '], "referralCode": "", "userattributeFileMap": {} }';
    formData.append('supportingInfo', JSON.stringify(newPayload));
    let  saveSupportUrl = '/wl-jobs-svc/api/v1/apply/saveSupportingInfo'
    if(this.supportDocFromEngagementService){
      saveSupportUrl = '/wl-jobs-svc/api/v2/apply/saveSupportingInfo'
    }
    const resp = await axios.post(
      saveSupportUrl,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: bearerToken,
        },
      },
    );
    return resp;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async postResume(payload: ResumePayload) {
    const bearerToken = 'Bearer ' + payload.accessToken;
    const formData = new FormData();
    var resumeName = payload.resume.resumename;
    if (resumeName && resumeName.includes("'")) {
      resumeName = resumeName.replace(/'/g, '0011111111111111100');
    }
    formData.append('resumefile', payload.resumefile, resumeName);
    formData.append(
      'resume',
      '{"resumename": "", "resumeLink":"' +
      payload.resumelink +
      '","jobpostingid":' +
      payload.jobpostingid +
      '}',
    );

    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/apply/resumes',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async postProfileResume(payload: ResumePayload) {
    const bearerToken = 'Bearer ' + payload.accessToken;
    const formData = new FormData();
    var resumeName = payload.resume.resumename;
    if (resumeName && resumeName.includes("'")) {
      resumeName = resumeName.replace(/'/g, '0011111111111111100');
    }
    formData.append('resumefile', payload.resumefile, resumeName);
    if(payload.accessToken.length==0){
      formData.append(
        'resume',
        '{"resumename": "", "resumeLink":"' +
        payload.resumelink +
        '","jobpostingid":' +
        payload.jobpostingid +","+
        "userId:"+payload.userId+
        '}',
      );
    }
    else{
    formData.append(
      'resume',
      '{"resumename": "", "resumeLink":"' +
      payload.resumelink +
      '","jobpostingid":' +
      payload.jobpostingid +
      '}',
    );
  }
    
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/resume',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getNexSteps(payload: ApplyRequestWrapper) {
    try {
      payload.applyRequest.referralCode = vxm.referrals.globalRefCode;
      console.log(vxm.utmtracker.utmTrackerId, 'utmTrackerId');
      if (vxm.utmtracker.utmTrackerId > 0) {
        payload.applyRequest.utmTrackerId = vxm.utmtracker.utmTrackerId;
      }
      let api = '/wl-jobs-svc/api/v2/apply?resumeCode=';
      const bearerToken = 'Bearer ' + vxm.users.getToken;
      const resp = await axios.post(api, payload.applyRequest, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      });
      this.setApplicationResponse(resp.data);
      return resp;
    } catch (error) {
      console.log([error]);
      if (error.response.status === 400) {
        (window as any).$cookies.set(
          'NavigateTo_ID',
          'JobDetails:' + payload.applyRequest.jobPostingId,
          300,
        );
      }
    }
    return;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async applyWithProfilResume(payload: JobApplication) {
    payload.referralCode = vxm.referrals.globalRefCode;
    console.log(vxm.utmtracker.utmTrackerId, 'utmTrackerId');
    if (vxm.utmtracker.utmTrackerId > 0) {
      payload.utmTrackerId = vxm.utmtracker.utmTrackerId;
    }
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resumeCode = payload.resumeCode || vxm.configs.getGlobalConfigValue('WL_RESUME_UPLOAD_REQUIRED');
    let api = '/wl-jobs-svc/api/v2/apply?resumeCode=';
    const resp = await axios.post(api + resumeCode, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    let apply = new Apply();
    apply = resp.data;
    console.log(resp.data);
    return apply;
  }

  @action({ mode: 'mutate' })
  public async quickAnonJobApply(formData: FormData) {
    try {
      if (vxm.referrals.globalRefCode)
        formData.append("referralCode", vxm.referrals.globalRefCode);
      const resumeCode = formData.get('resumeUploadRequired') || vxm.configs.getGlobalConfigValue('WL_RESUME_UPLOAD_REQUIRED');
      const api = '/wl-jobs-svc/api/v1/anon/apply?resumeCode=' + resumeCode;
      const resp = await axios.post(
        api,
        formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return resp.data;
      // router.push('Verification');
    } catch (error) {
      return error.response.data;
    }
  }


  @action({ mode: 'mutate'})
  public async quickAnonRegister(formData : FormData){
    try{
      const api = '/wl-jobs-svc/api/v1/anon/register';
      const resp = await axios.post(
        api,
        formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return resp.data;

    }catch (error){
      return error.response.data
    }
  }

  @action({ mode: 'mutate' })
  public async anonApplyWithResumeGuid(payload: JobApplication) {
    payload.referralCode = vxm.referrals.globalRefCode;
    console.log(vxm.utmtracker.utmTrackerId, 'utmTrackerId');
    if (vxm.utmtracker.utmTrackerId > 0) {
      payload.utmTrackerId = vxm.utmtracker.utmTrackerId;
    }
    const resumeCode = payload.resumeCode || vxm.configs.getGlobalConfigValue('WL_RESUME_UPLOAD_REQUIRED');
    let api = '/wl-jobs-svc/api/v1/apply/anon?resumeCode=' + resumeCode;
    const resp = await axios.post(api, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let apply = new Apply();
    apply = resp.data;
    return apply;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getApplyFlowResumeListing(token: string) {
    const bearerToken = 'Bearer ' + token;
    const resp = await axios.get('/wl-jobs-svc/api/v1/apply/resumes', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });

    let resumesList = new ResumeWrapper();
    resumesList = resp.data;
    this.setResumeListing(resumesList);
    return resp;
  }


  @action({ mode: 'mutate' })
  public async getAnonResumeListing(userId: number) {
    const resp = await axios.get('/wl-jobs-svc/api/v1/apply/resumes?userId='+userId, {
      headers: {
        'Content-Type': 'application/json'
      },
    })

    let resumesList = new ResumeWrapper();
    resumesList = resp.data;
    this.setResumeListing(resumesList);
    return resp;
  }

  @action({ mode: 'mutate' })
  public async getAnonApplyFlowResumeListing() {
    const resp = await axios.get('/wl-jobs-svc/api/v1/apply/anon/resumes?email=ksaurabh_89909999888@yopmail.com&companyCode=TCDEV', {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    let resumesList = new ResumeWrapper();
    resumesList = resp.data;
    this.setResumeListing(resumesList);
    return resp;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getResumeListing(token: string) {
    const bearerToken = 'Bearer ' + token;
    const resp = await axios.get('/wl-jobs-svc/api/v1/apply/resumes', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });

    let resumesList = new ResumeWrapper();
    resumesList = resp.data;
    this.setResumeListing(resumesList);
    // router.push({ name: "Resumes" });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getDefaultResume(token: string) {
    const bearerToken = 'Bearer ' + token;
    const resp = await axios.get('/wl-jobs-svc/api/v1/apply/resumes', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });

    let resumesList = new ResumeWrapper();
    resumesList = resp.data;
    this.setResumeListing(resumesList);
    return resumesList;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getCompanyInfo(payload: CandidatePortalClientCommonInfo) {
    const resp = await axios.post(
      '/wl-jobs-svc/api/anon/company/companyprofile',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    let company = new Company();
    company = resp.data;
    this.setCompanyInfo(company);
    return company;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async setDropboxAppKey(appKey: string) {
    const dbx = window.document.getElementById('dropboxjs');
    if (dbx) {
      dbx.setAttribute('data-app-key', appKey);
      const src = dbx.getAttribute('data-src');
      if (!!src) dbx.setAttribute('src', src);
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getJobFilters(ccode: string) {
    const resp = await axios.get(
      '/wl-jobs-svc/api/anon/job-posting/companycode/' + ccode,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    this.setFilterWrapper(resp.data);
    return resp;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getJobByID(jobID: string) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const lat = vxm.jobs.latitude;
    const long = vxm.jobs.longitude;
    const referralCode = vxm.referrals.ReferralWrapper.referralCode
    let url = '/wl-jobs-svc/api/v1/jobs/' + jobID;
    if (lat && long) {
      url += '?latitude=' + lat + '&longitude=' + long;
    } else if (referralCode) {
      url += '?referralCode=' + referralCode
    }
    const resp = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    resp.data.publishedJobs &&
      this.setAnonymousJobByID(resp.data.publishedJobs[0]);
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getCustomFilters(ccode: string) {
    const resp = await axios.get(
      '/wl-jobs-svc/api/anon/job-posting/jobs/customfilter/' + ccode,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    this.setCustomFilters(resp.data.customFilters || []);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async getAnonymousJobByID(jobID: string) {
    var lat = vxm.jobs.latitude;
    var long = vxm.jobs.longitude;
    const referralCode = vxm.referrals.ReferralWrapper.referralCode
    let url =
      '/wl-jobs-svc/api/anon/job-posting/' +
      jobID +
      '?companyCode=' +
      vxm.jobs.companyCode;
    if (referralCode) {
      url += '&referralCode=' + referralCode
    }
    if (lat && long) {
      url += '&latitude=' + lat + '&longitude=' + long;
    }
    const resp = await axios.get(url);
    resp.data.publishedJobs &&
      this.setAnonymousJobByID(resp.data.publishedJobs[0]);
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async getAnonymousJobByIDAndCompanyCode(jobID: string) {
    var lat = vxm.jobs.latitude;

    if (lat === undefined) {
      lat = 0;
    }
    var long = vxm.jobs.longitude;
    if (long === undefined) {
      long = 0;
    }
    console.log('lat:' + lat + ' long:' + long);
    const resp = await axios.get(
      '/wl-jobs-svc/api/anon/job-posting/' +
      this.companyCode +
      '/' +
      jobID +
      '?latitude=' +
      lat +
      '&longitude=' +
      long,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    resp.data.publishedJobs &&
      this.setAnonymousJobByID(resp.data.publishedJobs[0]);
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async createJobAlert(jobAlert: JobAlert) {
    const resp = await axios.post('/wl-jobs-svc/api/anon/jobalerts', jobAlert, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return resp.data;
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async validateJobAlertByHash(hash: any) {
    const resp = await axios.post(
      '/wl-jobalert-service/api/v1/jobalerts/validate',
      hash,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async validateJobAlertEmail(hash: string) {
    const resp = await axios.post(
      '/wl-jobs-svc/api/anon/jobalerts/validate',
      hash,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async deactivateJobAlerts(hash: string) {
    hash = hash.replace(/ /g, '+');
    let companyCode = vxm.jobs.BrandingInfo.companycode;
    let url = `/wl-jobs-svc/api/anon/jobalerts/deactivateAlerts?code=${encodeURIComponent(
      hash,
    )}&companycode=${companyCode}`;
    const resp = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return resp.data;
  }

  /////////////////////////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async getUserAnsweredAll(payload: SurveyDetailRequest) {
    const data = payload;
    const resp = await axios.post(
      '/atsuser/api/anon/candidate-survey/userfullresponse',
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    const surveyQuestionResponse = new SurveyQuestionResponse();
    surveyQuestionResponse.hasAnsweredAll = resp.data;
    console.log([resp.data]);
  }

  /////////////////////////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async getCandidateSurveyDetails(payload: SurveyDetailRequest) {
    console.log('payload--', [payload]);
    let surveyUrl = '/atsuser/v2/api/anon/candidate-survey/surveydetail';
    if(this.callEngagementService){
      surveyUrl = '/engagement/v2/api/anon/candidate-survey/surveydetail';
    }
    const resp = await axios.post(
      surveyUrl,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return resp.data;
  }

  /////////////////////////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async getCandidateSurveyDetail(payload: SurveyDetailRequest) {
    console.log('payload--', [payload]);
    let surveyUrl = '/atsuser/api/anon/candidate-survey/surveydetail';
    if(this.callEngagementService){
      surveyUrl = '/engagement/v2/api/anon/candidate-survey/surveydetail';
    }
    const resp = await axios.post(
      surveyUrl,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    console.log([resp.data]);

    const surveyDetailResponse = new SurveyDetailResponse();

    let survey = new Survey();

    const questionnaire = new Questionnaire();

    questionnaire.questions = resp.data.questions;

    survey = resp.data.survey;
    surveyDetailResponse.survey = survey;
    surveyDetailResponse.surveyUserQualifierId =
      resp.data.surveyUserQualifierId;
    surveyDetailResponse.surveyMessage = resp.data.surveyMessage;

    this.setQuestionnaire(questionnaire);

    console.log(questionnaire);
    const qaResponse = new QuestionnaireResponse();
    questionnaire.questions.forEach((elm) => {
      const qrData = new QuestionResponseData();
      qrData.questionID = elm.questionID + '';

      if (elm.questionType === '01') {
        if (elm.userQuestionResponse == null) {
          elm.answerList.forEach(() => {
            qrData.userQuestionResponse.userAnswerList.push('');
          });
        } else {
          if (elm.userQuestionResponse.userAnswerList.length > 0) {
            elm.userQuestionResponse.userAnswerList.forEach((itm) => {
              qrData.userQuestionResponse.userAnswerList.push(itm);
            });
          }
        }
      }

      if (elm.questionType === '03') {
        if (elm.userQuestionResponse == null) {
          qrData.userQuestionResponse.userAnswerList.push('');
        } else {
          if (elm.userQuestionResponse.userAnswerList.length > 0) {
            elm.userQuestionResponse.userAnswerList.forEach((itm) => {
              qrData.userQuestionResponse.userAnswerList.push(itm);
            });
          }
        }
      }

      if (elm.questionType === '04') {
        if (elm.userQuestionResponse == null) {
          if (elm.maxLength) {
            elm.characterLength = elm.maxLength;
            elm.lengthLeft = elm.maxLength;
          } else {
            elm.characterLength = 150;
            elm.lengthLeft = 150;
          }
        } else {
          let lengthOfChars =
            elm.userQuestionResponse.questionTextResponse.length;
          if (elm.maxLength) {
            elm.characterLength = elm.maxLength;
            elm.lengthLeft = elm.maxLength - lengthOfChars;
          } else {
            elm.characterLength = 150;
            elm.lengthLeft = elm.characterLength - lengthOfChars;
          }
        }
      }

      qaResponse.questionResponseData.push(qrData);
    });
    this.setQAResponse(qaResponse);
    surveyDetailResponse.questionnaireResponse = qaResponse;
    console.log(JSON.stringify(surveyDetailResponse));
    this.setSurveyDetailResponse(surveyDetailResponse);
  }

  @action({ mode : 'mutate'})
  public async getAnonJobApplicationBranchedQuestions(payload: QuestionnaireDetailRequest){
    const resp = await axios.post(`/engagement/api/v2/anon/questionnaires`,payload,
    {
       headers:{
        'Content-Type': 'application/json',
       }
    });
    return resp.data;
      
  }
  
  @action({ mode: 'mutate' })
  public async  surveyFieldValidation( surveyFieldData : SurveyFieldValidation){
    console.log("survey field validation payload",surveyFieldData);
    let validationUrl = '/engagement/api/v1/attribute/validation';
    const resp =   await axios.post(
        validationUrl,
        surveyFieldData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log("response in jobs store",resp.data);
      return resp.data;
  }

  @action({ mode: 'mutate' })
  public async saveSurveyResponse(
    surveyQuestionResponse: SurveyQuestionResponse,
  ) {
    console.log('surveyQuestionResponse', surveyQuestionResponse);
    let surveyUrl = '/atsuser/v2/api/anon/candidate-survey/savesurveyresponse';
    if(this.callEngagementService){
      surveyUrl = '/engagement/v2/api/anon/candidate-survey/savesurveyresponse';
    }
    const resp = await axios.post(
      surveyUrl,
      surveyQuestionResponse,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    console.log(resp.data);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async canSubmitSurveyResponse(
    surveyQuestionResponse: SurveyQuestionResponse,
  ) {
    const resp = await axios.post(
      '/engagement/v2/api/anon/candidate-survey/cansubmitsurvey',
      surveyQuestionResponse,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    console.log(resp.data);
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getNewJobHistory({ pageNum, pageSize }) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const url = `/wl-profile-svc/api/v1/jobHistory?companyCode=${this.BrandingInfo.companycode
      }&pageNum=${pageNum}&pageSize=${pageSize}`;
    const resp = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    if (resp.data.meta && resp.data.meta.success) {
      const pg = new Pager();
      pg.resultCount = resp.data.page.totalCount;
      pg.resultSize = resp.data.page.pageSize;
      pg.resultPage = resp.data.page.pageNumber;
      this.setJobHistoryPager(pg);
      if (Array.isArray(resp.data.data.jobHistories)) {
        resp.data.data.jobHistories.forEach((history) => {
          if (history.startDTTM) {
            history.startDTTM = vxm.utility.convertUTCToLocalTime(
              history.startDTTM,
            );
          }
          if (history.endDTTM) {
            history.endDTTM = vxm.utility.convertUTCToLocalTime(
              history.endDTTM,
            );
          }
        });
      }
      this.setUserJobHistoryListResponse(resp.data.data);
      this.setUserJobHistoryListResponseCopy(
        JSON.parse(JSON.stringify(resp.data.data)),
      );
      return resp.data.data;
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getJobHistory(
    userJobHistoryListRequest: UserJobHistoryListRequest,
  ) {
    this.setUserJobHistoryListRequest(userJobHistoryListRequest);
    console.log('userJobHistoryListRequest', userJobHistoryListRequest);
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/jobHistory',
      userJobHistoryListRequest,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );

    const pg = new Pager();
    pg.resultCount = resp.data.resultCount;
    pg.resultSize = resp.data.resultSize;
    pg.resultPage = resp.data.resultPage;
    this.setJobHistoryPager(pg);
    this.setUserJobHistoryListResponse(resp.data);
    this.setUserJobHistoryListResponseCopy(
      JSON.parse(JSON.stringify(resp.data)),
    );
    return resp.data;
    // router.push({ name: 'JobHistory' });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async deleteJobHistory(userJobHistory: UserJobHistory) {
    console.log('userJobHistoryUpdate', userJobHistory);
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      `/wl-profile-svc/api/v1/jobHistory/${userJobHistory.jobHistoryId}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );

    this.setUserJobHistoryUpdateResponse(resp.data);
    // router.push({ name: 'JobHistory' });
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async updateJobHistory(userJobHistory: UserJobHistory) {
    if (userJobHistory.startDTTM) {
      userJobHistory.startDTTM = vxm.utility.convertLocalTimeToUTC(
        new Date(userJobHistory.startDTTM),
      );
      userJobHistory.endDTTM = vxm.utility.convertLocalTimeToUTC(
        new Date(userJobHistory.endDTTM),
      );
    }
    console.log('userJobHistoryUpdate', userJobHistory);
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/jobHistory',
      userJobHistory,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );

    this.setUserJobHistoryUpdateResponse(resp.data);
    // router.push({ name: 'JobHistory' });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async bookmarkJob(bookmarks: any): Promise<any> {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/userJobStatus/bookmarkJob',
      bookmarks,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp;
  }

  @action({ mode: 'mutate' })
  public async saveLocalJobs() {
    if (!(vxm.users.isLoggedIn && localStorage.getItem('localjobs'))) return;

    const localjobs = JSON.parse(localStorage.getItem('localjobs') || '[]');
    const bookmarks = localjobs.map((job) => ({
      action: 'A',
      objectId: job.jobPostingId,
      type: '01',
    }));
    const respPromise = this.bookmarkJob({ bookmarks });
    Promise.all([respPromise]).then(
      ([{ data }]) => {
        if (data.sessionValid === true) {
          localStorage.setItem('localjobs', JSON.stringify([]));
          vxm.utility.setLocaljobs([]);
        }
      },
      (err) => {
        console.log(err);
      },
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async submitJobApplyIntermediateFlow(
    workFlowStepSubmitRequest: WorkFlowStepSubmitRequest,
  ): Promise<any> {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/applicationsteps',
      workFlowStepSubmitRequest,

      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp;
  }

  @action({mode: 'mutate'})
  public async rejectInterviewAppointmentSlot(InterviewAppointmentReject:InterviewAppointmentReject): Promise<any>{
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/applicationsteps/rejectAppointmentRound',
      InterviewAppointmentReject,

      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp;

  }

  
  @action({mode: 'mutate'})
  public async acceptInterviewAppointmentSlot(InterviewAppointmentAccept: any): Promise<any>{
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/applicationsteps/acceptAppointmentRound',
      InterviewAppointmentAccept,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp;

  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async fetchOfferLetter(
   jobPostingId:number,
  ){
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/workllama-api-service/api/v1/jobpostingassignments/offerLetterPDF',
      {
        'jobPostingAssignmentId':jobPostingId
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },

      },
    );
    return resp;
  }

  @action({ mode: 'mutate' })
  public async getMyJobStatus(
    userJobListRequest: UserJobListRequest,
  ): Promise<any> {
    this.setUserJobListRequest(userJobListRequest);
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    var lat = vxm.jobs.latitude;

    if (lat === undefined) {
      lat = 0;
    }
    var long = vxm.jobs.longitude;
    if (long === undefined) {
      long = 0;
    }
    console.log('lat:' + lat + ' long:' + long);
    var apiString = '/wl-jobs-svc/api/v1/userJobStatus' ;
    if (lat && long ) {
    apiString = apiString+'?lat=' + lat + '&long=' + long
    }
    const resp = await axios.post(
      apiString,
      userJobListRequest,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    const pg = new Pager();
    pg.resultCount = resp.data.resultCount;
    let resObj = {
      jobStatus: resp.data.jobStatus,
      resultCount: resp.data.resultCount,
      resultPage: resp.data.resultPage,
      resultSize: resp.data.resultSize,
      sessionToken: '123',
    };
    this.setResultCount(resObj);
    pg.resultSize = resp.data.resultSize;
    pg.resultPage = resp.data.resultPage;
    this.setJobPager(pg);
    this.setJobListings(resp.data.userJobs);
    this.setJobTags(resp.data.tagConfigs);
    userJobListRequest.jobStatus === '04' &&
      this.setSavedJobListings(resp.data.userJobs);
    return resp;
  }

  @action({ mode: 'mutate' })
  public async getJobStatus(userJobListRequest: UserJobListRequest) {
    this.setUserJobListRequest(userJobListRequest);
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/userJobStatus',
      userJobListRequest,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );

    const pg = new Pager();
    pg.resultCount = resp.data.resultCount;
    pg.resultSize = resp.data.resultSize;
    pg.resultPage = resp.data.resultPage;
    this.setMyJobsPager(pg);

    this.setUserJobHStatusResponse(resp.data);
    router.push({ name: 'myjobstatus' });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getCompanyListing(query: string) {
    const companyCode = vxm.users.getCompanyCode;
    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/jobHistory/company/' + companyCode,
      query,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    this.setUserCompanyListing(resp.data);
  }

  @action({ mode: 'mutate' })
  public async getJobAlertsFrequency() {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get('/wl-jobs-svc/api/v2/jobalerts/frequency', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async getJobAlerts(email: string) {
    const resp = await axios.get(
      '/wl-jobs-svc/api/anon/jobalerts/' +
      this.BrandingInfo.companycode +
      '/' +
      email,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return resp.data;
  }
  @mutation
  public setJobAlertListings(jobalerts: []) {
    this.jobAlertListings = jobalerts;
  }
  public get JobAlertListings() {
    return this.jobAlertListings;
  }
  @mutation
  public setAlertRefresh(val: boolean) {
    this.alertRefresh = val;
  }
  public get AlertRefresh() {
    return this.alertRefresh;
  }

  @mutation
  public setJobAlertLocationInfo(val: any) {
    this.jobAlertLocationInfo = val;
  }
  public get JobLocationInfo() {
    return this.jobAlertLocationInfo;
  }


  @mutation
  public setMapViewMode(val: boolean) {
    this.mapViewMode = val;
  }
  public get getMapViewMode() {
    return this.mapViewMode;
  }

  @action({ mode: 'mutate' })
  public getJobAlertV2(jobAlertId: number) {
    return axios
      .get(
        `/wl-jobalert-service/api/v1/anonjobalerts/getjobalert/${jobAlertId}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      .then((json) => {
        const {
          data: {
            data: { jobAlert },
          },
        } = json;
        return jobAlert;
      })
      .catch((err) => {
        console.log('Error: ', err);
        return null;
      });
  }

  @action({ mode: 'mutate' })
  public async getJobAlertsV2(jobList: JobAlertListV2) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobalert-service/api/v1/jobalerts/list',
      jobList,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    const pg = new Pager();

    pg.resultCount = resp.data.data.pageSize;
    pg.resultSize = resp.data.data.resultSize;
    pg.resultPage = resp.data.data.pageNumber;
    this.setMyAlertPager(pg);
    this.setAlertRefresh(true);
    this.setJobAlertListings(resp.data.data.jobAlertList);

    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async getJobAlert(jobAlertId) {
    const resp = await axios.get(
      '/wl-jobs-svc/api/anon/jobalert/' + jobAlertId,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async createCommonJobAlert(commonJobAlert: CommonJobAlert) {
    const resp = await axios.post(
      '/wl-jobs-svc/api/anon/jobalerts/save',
      commonJobAlert,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async createCommonJobAlertV2(commonJobAlert: CommonJobAlertV2) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobalert-service/api/v1/jobalerts',
      commonJobAlert,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async deleteJobAlert(id: number) {
    const resp = await axios.put('/wl-jobs-svc/api/anon/jobalerts/' + id, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return resp;
  }

  @action({ mode: 'mutate' })
  public async triggerJobAlertActivationEmail(jobAlertid: number) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      `/wl-jobalert-service/api/v1/jobalerts/triggerAlertActivationEmail/${jobAlertid}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async deleteJobAlertV2(JobDeleteV2: JobDeleteV2) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobalert-service/api/v1/jobalerts/delete',
      JobDeleteV2,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async pauseJobAlertV2(pauseJobAlertV2: JobAlertPauseV2) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobalert-service/api/v1/jobalerts/pause',
      pauseJobAlertV2,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async resumeAllAlerts(payload) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobalert-service/api/v1/jobalerts/activate',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async activateJobAlertV2(email: string) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobalert-service/api/v1/jobalerts/activate',
      {
        jobAlertIds: [this.jobAlertid],
        activateAllJobAlerts: false,
        companyCode: this.BrandingInfo.companycode,
        email: email,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async updateCommonJobAlert(commonJobAlert: CommonJobAlert) {
    const resp = await axios.post(
      '/wl-jobs-svc/api/anon/jobalerts/update',
      commonJobAlert,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async updateCommonJobAlertV2(jobalert: CommonJobAlertV2) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.put(
      '/wl-jobalert-service/api/v1/jobalerts/' + this.jobAlertid,
      jobalert,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );

    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async deactivateJobAlert(hash: string) {
    const resp = await axios.post(
      '/wl-jobs-svc/api/anon/jobalerts/deactivate',
      hash,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getJobApplicationWorkflowSteps(jobPostingId: string) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      `/wl-jobs-svc/api/v1/applicationsteps/${jobPostingId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken
        },
      },
    );

    if (resp.data && resp.data.sessionValid) {
      this.setJobApplicationWorkflowSteps(resp.data.workflowStep);
      this.setInterviewManagementReasonCodes(resp.data.reasonCodes)
    }
  }


  @action({ mode: 'mutate' })
  public async getNewJobApplicationWorkflowSteps(jobPostingId: string) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      `/wl-jobs-svc/api/v1/applicationsteps/new/${jobPostingId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken
        },
      },
    );

    if (resp.data && resp.data.sessionValid) {
      this.setJobApplicationWorkflowSteps(resp.data.workflowStep);
      this.setInterviewManagementReasonCodes(resp.data.reasonCodes)
    }
  }

  @action({ mode: 'mutate' })
  public async getAnonJobApplicationWorkflowSteps(jobPostingId: string) {
    const resp = await axios.get(
      `/wl-jobs-svc/api/v2/anon/jobapplicationsteps/${jobPostingId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    if (resp.data && resp.data.sessionValid) {
      this.setJobApplicationWorkflowSteps(resp.data.workflowStep);
    }
  }

  @action({ mode: 'mutate' })
  public async searchClaimableConversations(payload: any) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const response = await axios.post(
      '/chatservice/searchclaimableconversations',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );

    return response.data;
  }

  @action({ mode: 'mutate' })
  public async fetchConversation(payload: any) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const response = await axios.post(
      '/chatservice/fetchconversation',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return response.data;
  }
  @action({ mode: 'mutate' })
  public async sendMessage(payload: any) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const response = await axios.post('/chatservice/sendmessage', payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    return response.data;
  }
  @action({ mode: 'mutate' })
  public async fetchExistingConversation(payload: any) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const response = await axios.post(
      '/chatservice/fetchexistingconversation',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async conversationsAction(payload: any) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const response = await axios.put('/chatservice/conversations', payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    });
    return response.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async submitJobFlow(
    workFlowStepSubmitRequest: WorkFlowStepSubmitRequest,
  ): Promise<any> {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/userJobStatus/jobWorkflowSubmission',
      workFlowStepSubmitRequest,

      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp;
  }

  @action({ mode: 'mutate' })
  public async updateJobAlertFrequency(payload: any) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const response = await axios.post(
      '/wl-jobs-svc/api/v2/jobalerts/frequency',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async getSimilarJobs({ jobId, companyCode }) {
    const token = 'Bearer ' + vxm.users.getToken;
    try {
      vxm.utility.setSpinnerEnabled(false);
      const resp = await axios.get(
        `/document-matching-svc/webhooks/get_matching_jobs?jobId=${jobId}&companyCode=${companyCode}`,
        { headers: { 'Content-Type': 'application/json', Authorization: token } },
      );
      if (resp.data.meta.success) {
        this.setSimilarJobs(resp.data.data.similarJobs);
      }
    } finally {
      vxm.utility.setSpinnerEnabled(true);
    }
  }
}

